export function useRoles(t: TypeAny) {
  return [
    {
      value: 'ADMIN',
      display: t('roles.ADMIN')
    },
    {
      value: 'EXTERNAL_PARTNER',
      display: t('roles.EXTERNAL_PARTNER')
    },
    {
      value: 'MARKETING_MANAGER',
      display: t('roles.MARKETING_MANAGER')
    }
  ];
}
